import { memo, useMemo } from 'react';

import chunkArray from '@Utils/chunkArray';
import useMedias from '@Hooks/useMedias';
import CategoryGroup from '../CategoryGroup';
import GallerySection from '@Components/GallerySection';

import type { OfferCategoryData } from '@Pages/PagePromotionsDiscounts/typings';
import type { FC, HTMLAttributes } from 'react';

interface CurrentDiscountsProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  categories: OfferCategoryData[];
}

const CurrentDiscounts: FC<CurrentDiscountsProps> = (props) => {
  const { title, categories, ...restProps } = props;
  const { isDesktop, isMobileM, isMobile } = useMedias();

  const slides = useMemo(() => {
    let countInSlide = 8;
    if (isDesktop) countInSlide = 6;
    if (isMobileM) countInSlide = 4;
    if (isMobile) countInSlide = 2;

    return chunkArray(categories, countInSlide);
  }, [categories, isDesktop, isMobile, isMobileM]);

  return (
    <GallerySection
      title={title}
      slides={slides}
      fullWidth
      defaultGap
      renderSlide={(group) => <CategoryGroup group={group} />}
      scrollbar={false}
      pagination
      {...restProps}
    />
  );
};

export default memo(CurrentDiscounts);
